<template>
  <button @click="exportTransaction" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  name: "LakeCreditTransactionExport",
  props: ['filter'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.export = true;
      params.page = 1;
      params.pageSize = 1000;
      params.queryExecutionId = null;
      params.nextToken = null;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/lake-credit-transaction', {
          params: params
        });
        params.page += 1;
        response = result.data;
        params.queryExecutionId = response.queryExecutionId;
        params.nextToken = response.nextToken;
        response.docs.forEach(item => {
            let row = {
                  amount: item.amount,
                  content: item.content,
                  afterBalance: item.beforeBalance + item.amount,
                  time: item.createTime ? moment(item.createTime).format('DD/MM/YYYY HH:mm:ss') : '',
                  ref: item.ref
                }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (params.nextToken);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'callio-lake-credit-transaction.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      let cols = [
        {header: 'amount', key: 'amount', width: 20},
        {header: 'content', key: 'content', width: 15},
        {header: 'afterBalance', key: 'afterBalance', width: 15},
        {header: 'time', key: 'time', width: 15},
        {header: 'ref', key: 'ref', width: 15},
      ];
      let row = {
        amount: this.$t("amount"),
        content: this.$t("content"),
        afterBalance: this.$t("afterBalance"),
        time: this.$t("time"),
        ref: this.$t("ref")
      };
      sheet.columns = cols;
      sheet.addRow(row);
    },
    close() {
      this.cancelRequest = true;
    }
  },

}
</script>